import {type PropsWithChildren, createContext, useContext, useMemo} from 'react'
import type {UpsellInfo} from '../types/rules-types'

const defaultUpsellInfo: UpsellInfo = {
  rulesets: {
    featureEnabled: false,
    cta: {
      visible: false,
    },
  },
  enterpriseRulesets: {
    featureEnabled: false,
    cta: {
      visible: false,
    },
  },
  organization: false,
  askAdmin: false,
}

export const UpsellInfoContext = createContext<UpsellInfo>(defaultUpsellInfo)

export function UpsellInfoProvider({children, upsellInfo}: PropsWithChildren<{upsellInfo?: UpsellInfo}>) {
  const value = useMemo(() => upsellInfo ?? defaultUpsellInfo, [upsellInfo])
  return <UpsellInfoContext.Provider value={value}>{children}</UpsellInfoContext.Provider>
}

export function useUpsellInfoContext(): UpsellInfo {
  const context = useContext(UpsellInfoContext)
  if (!context) {
    throw new Error('useUpsellInfoContext must be used within a UpsellInfoProvider')
  }
  return context
}

try{ UpsellInfoContext.displayName ||= 'UpsellInfoContext' } catch {}
try{ UpsellInfoProvider.displayName ||= 'UpsellInfoProvider' } catch {}